import { useState } from "react";
import { Link } from "react-router-dom";

import { dataHora } from "../api.ts";
import { Cartao, Vazio } from "../componentes/basicos.tsx";
import { useDados } from "../usarDados.ts";

type Resposta = {
  registros: {
    id: number; ocorrido_em: string; ator: string; acao: string;
    entidade: string; entidade_id: number | null;
    detalhe: Record<string, unknown>; ip: string;
  }[];
  atores: string[];
  pagina: number;
  limite: number;
};

const ENTIDADES = ["", "empresa", "licenca", "maquina", "usuario", "chave"];
const PERIODOS: [string, string][] = [["", "tudo"], ["7", "7 dias"], ["30", "30 dias"], ["90", "90 dias"]];

/** O alvo vira link: antes a auditoria era beco sem saida. */
function Alvo({ entidade, id }: { entidade: string; id: number | null }) {
  if (!id) return <span className="suave">{entidade}</span>;
  const rota: Record<string, string> = {
    empresa: `/empresas/${id}`, licenca: `/licencas/${id}`, maquina: `/maquinas/${id}`,
  };
  const destino = rota[entidade];
  return destino
    ? <Link to={destino}>{entidade} {id}</Link>
    : <span className="suave">{entidade} {id}</span>;
}

export function Auditoria() {
  const [entidade, setEntidade] = useState("");
  const [ator, setAtor] = useState("");
  const [dias, setDias] = useState("");
  const [pagina, setPagina] = useState(1);
  const [aberto, setAberto] = useState<number | null>(null);

  const q = new URLSearchParams({ pagina: String(pagina) });
  if (entidade) q.set("entidade", entidade);
  if (ator) q.set("ator", ator);
  if (dias) q.set("dias", dias);

  const { dados: r, erro, carregando } = useDados<Resposta>(`/auditoria?${q}`);

  return (
    <>
      <h1>Auditoria</h1>
      <p className="suave pequeno" style={{ marginTop: "calc(-1 * var(--e-md))" }}>
        Registro do que muda acesso ou licenca. Nada e apagado daqui.
      </p>

      <Cartao>
        <div className="linha" style={{ marginBottom: "var(--e-md)" }}>
          <label className="campo mb-0" style={{ width: 160 }}>
            <span className="campo__rotulo">Entidade</span>
            <select value={entidade} onChange={(e) => { setEntidade(e.target.value); setPagina(1); }}>
              {ENTIDADES.map((e) => <option key={e} value={e}>{e || "todas"}</option>)}
            </select>
          </label>
          <label className="campo mb-0" style={{ width: 180 }}>
            <span className="campo__rotulo">Quem</span>
            <select value={ator} onChange={(e) => { setAtor(e.target.value); setPagina(1); }}>
              <option value="">todos</option>
              {(r?.atores ?? []).map((a) => <option key={a} value={a}>{a}</option>)}
            </select>
          </label>
          <label className="campo mb-0" style={{ width: 140 }}>
            <span className="campo__rotulo">Periodo</span>
            <select value={dias} onChange={(e) => { setDias(e.target.value); setPagina(1); }}>
              {PERIODOS.map(([v, t]) => <option key={v} value={v}>{t}</option>)}
            </select>
          </label>
        </div>

        {carregando && <div className="carregando">carregando...</div>}
        {erro && <div className="alerta alerta--erro">{erro}</div>}
        {r && r.registros.length === 0 && <Vazio titulo="Nenhum registro neste filtro" />}

        {r && r.registros.length > 0 && (
          <>
            <div className="tabela-rolagem">
              <table className="tabela">
                <thead>
                  <tr><th>Quando</th><th>Quem</th><th>IP</th><th>Acao</th><th>Alvo</th><th></th></tr>
                </thead>
                <tbody>
                  {r.registros.map((a) => [
                    <tr key={a.id} onClick={() => setAberto(aberto === a.id ? null : a.id)}
                        style={{ cursor: "pointer" }}>
                      <td className="suave pequeno">{dataHora(a.ocorrido_em)}</td>
                      <td>{a.ator}</td>
                      {/* O IP sempre foi gravado e consultado; so faltava exibir.
                          O runbook manda literalmente olhar de qual IP veio. */}
                      <td className="tabela__mono">{a.ip || "--"}</td>
                      <td className="tabela__mono">{a.acao}</td>
                      <td className="pequeno"><Alvo entidade={a.entidade} id={a.entidade_id} /></td>
                      <td className="apagado micro">
                        {Object.keys(a.detalhe ?? {}).length > 0 ? "ver" : ""}
                      </td>
                    </tr>,
                    aberto === a.id && Object.keys(a.detalhe ?? {}).length > 0 ? (
                      <tr key={`${a.id}-d`}>
                        <td colSpan={6} style={{ background: "var(--superficie-alt)" }}>
                          <dl className="perfil">
                            {Object.entries(a.detalhe).map(([k, v]) => (
                              <div key={k} style={{ display: "contents" }}>
                                <dt>{k}</dt><dd className="mono pequeno">{String(v)}</dd>
                              </div>
                            ))}
                          </dl>
                        </td>
                      </tr>
                    ) : null,
                  ])}
                </tbody>
              </table>
            </div>

            <div className="linha mt-lg">
              <button className="botao botao--secundario botao--pequeno" type="button"
                      disabled={pagina <= 1} onClick={() => setPagina((p) => p - 1)}>Anterior</button>
              <span className="pequeno suave">pagina {r.pagina}</span>
              <button className="botao botao--secundario botao--pequeno" type="button"
                      disabled={r.registros.length < r.limite}
                      onClick={() => setPagina((p) => p + 1)}>Proxima</button>
            </div>
          </>
        )}
      </Cartao>
    </>
  );
}
